import {selectedLocationFields,municipalityFields} from '../../../geo/locationFields';
import { camposHorario, horaObligatoria, trayectosSeleccionados } from './horariosTraslado';
import { guardarLote } from './programacionLote';
import useCiudadesTraslado, { resolverUbicacion } from './useCiudadesTraslado';
import SelectUbicacionPermitida from './SelectUbicacionPermitida';
import { motivoIntercambio } from './intercambioTraslado';
import useGeografiaTraslado, { tiposLugar, invertirTipos } from './useGeografiaTraslado';
import { Alert as GeografiaAlert } from 'antd';
// src/Components/modules/Authorizations/TrasladoDialog.js

import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Form,
  Input,
  Button,
  Row,
  Col,
  Typography,
  Select,
  DatePicker,
  TimePicker,
  message,
  Card,
  Tag,
  InputNumber,
  Spin,
  Popover,
} from "antd";

import {
  UserOutlined,
  FileTextOutlined,
  InfoCircleOutlined,
  MedicineBoxOutlined,
  CarOutlined,
  AimOutlined,
  SwapOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import api from "../../../axiosConfig";
import dayjs from "../../../utils/dayjs";
import { geoJsonToString, coordinateValidationRule } from "../../../utils/coordinates";

// IMPORTAMOS NUESTROS DOS COMPONENTES DE MAPA
import MapDialog from "../../../Resources/GoogleApi/MapDialog"; // Para buscar y seleccionar coordenadas
import MapRoute from "./MapDialog"; // Para ver la ruta con leaflet-routing-machine

import AgendarDialog from "./AgendarDialog";
import { useUser } from "../../../UserContext";
import { useServerTime } from "../../../ServerTimeContext";
import { formatCurrencyCOP } from "../../../utils/formatCurrency";

import "./TrasladoDialog.css";

const { TextArea } = Input;
const { Title } = Typography;
const { Option } = Select;

/**
 * Paleta de colores según estado del paciente.
 */
const estadoColors = {
  Activo: "green",
  Suspendido: "red",
  Fallecido: "black",
  Hospitalizado: "gray",
};

/**
 * Paleta de colores según estado de la autorización.
 */
const autorizacionEstadoColors = {
  activa: "geekblue",
  suspendida: "volcano",
  completada: "green",
  cerrada: "purple",
};

function FormularioTraslado({ open, onClose, onSubmit, initialPacienteId, initialAutorizacionId, disabledPacienteSelect, disabledAutorizacionSelect, isTai = null }) {
  const { user } = useUser();
  const { getServerTime, isToday: serverIsToday } = useServerTime();

  // ==============================
  // == Estados principales
  // ==============================
  const [patients, setPatients] = useState([]); // Simple list for dropdown
  const [autorizaciones, setAutorizaciones] = useState([]);

  // Rango de fechas para la autorización
  const [minFecha, setMinFecha] = useState(null);
  const [maxFecha, setMaxFecha] = useState(null);

  // Para controlar el modal "MapDialog" (búsqueda coords) y "MapRoute" (ver ruta)
  const [mapVisible, setMapVisible] = useState(false);
  const [mapMode, setMapMode] = useState(null); // "origen", "destino" o null (ver ruta)

  // Estados para la ruta
  const [origin, setOrigin] = useState(null);
  const [destination, setDestination] = useState(null);
  const [calculatedDistance, setCalculatedDistance] = useState(null);
  const [calculatedDuration, setCalculatedDuration] = useState(null);
  const [showLoading, setShowLoading] = useState(false);

  // Para el modal "Agendar"
  const [isAgendarVisible, setIsAgendarVisible] = useState(false);
  const [isAgendarDisabled, setIsAgendarDisabled] = useState(true);

  // Formulario principal
  const [form] = Form.useForm();
  const geografiaTraslado = useGeografiaTraslado(form);
  const [selectedDate, setSelectedDate] = useState(null);

  // Estado para autorización cerrada y su calendario
  const [tipoAutorizacion, setTipoAutorizacion] = useState(null);
  const [calendarioAutorizacion, setCalendarioAutorizacion] = useState([]);

  // ==============================
  // == Estados para INSTITUCIONES
  // ==============================
  const [instituciones, setInstituciones] = useState([]);
  const [searchTextOrigen, setSearchTextOrigen] = useState("");
  const [searchTextDestino, setSearchTextDestino] = useState("");
  const [origenSelectOpen, setOrigenSelectOpen] = useState(false);
  const [destinoSelectOpen, setDestinoSelectOpen] = useState(false);

  // Para saber si estamos usando un "Lugar Temporal"
  const [origenEsTemporal, setOrigenEsTemporal] = useState(false);
  const [destinoEsTemporal, setDestinoEsTemporal] = useState(false);

  // ---------------------------------------
  // Estados para Departamentos y Ciudades
  // ---------------------------------------
  const [departamentos, setDepartamentos] = useState([]);

  //const [isSubmitting, setIsSubmitting] = useState(false);
  //const [showLoading, setShowLoading] = useState(false);

  // =======================
  // == useEffects Carga  ==
  // =======================
  useEffect(() => {
    // Cargar pacientes simples para dropdown
    const fetchPatients = async () => {
      try {
        const response = await api.get("/pacientes/simple");

        // Validar que la respuesta sea un array
        let patientsData = [];
        if (Array.isArray(response.data)) {
          patientsData = response.data;
        } else if (response.data && Array.isArray(response.data.rows)) {
          // Si la respuesta tiene estructura { rows: [...] }
          patientsData = response.data.rows;
        } else if (response.data && Array.isArray(response.data.data)) {
          // Si la respuesta tiene estructura { data: [...] }
          patientsData = response.data.data;
        } else {
          console.warn(
            "⚠️ Respuesta de pacientes no es un array:",
            response.data
          );
          patientsData = [];
        }

        setPatients(patientsData);
      } catch (error) {
        console.error("Error al obtener pacientes:", error);
        setPatients([]); // Asegurar que siempre sea un array
      }
    };
    fetchPatients();

    // Cargar instituciones
    const fetchInstituciones = async () => {
      try {
        const resp = await api.get("/instituciones");
        setInstituciones(resp.data || []);
      } catch (error) {
        console.error("Error al obtener instituciones:", error);
      }
    };
    fetchInstituciones();
  }, []);

  // Función para cargar departamentos
  const fetchDepartamentos = useCallback(async () => {
    try {
      const response = await api.get("/departamentos");
      setDepartamentos(response.data);
    } catch (error) {
      console.error("Error al obtener departamentos:", error);
      message.error("Error al cargar los departamentos.");
    }
  }, []);

  const cacheCiudades = useRef({});

  // Función para cargar ciudades
  const fetchCiudades = useCallback(async (departamentoId) => {
    if (!departamentoId) return [];
    try {
      const response = await api.get(
        `/ciudades?departamento_id=${departamentoId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener ciudades:", error);
      message.error("Error al cargar las ciudades.");
      return [];
    }
  }, []);

  const ciudadesOrigen = useCiudadesTraslado(form, 'origen', departamentos, fetchCiudades, cacheCiudades, geografiaTraslado.contexto ? (geografiaTraslado.contexto.configurada ? geografiaTraslado.contexto.ambitos?.origen ?? null : null) : undefined);
  const ciudadesDestino = useCiudadesTraslado(form, 'destino', departamentos, fetchCiudades, cacheCiudades, geografiaTraslado.contexto ? (geografiaTraslado.contexto.configurada ? geografiaTraslado.contexto.ambitos?.destino ?? null : null) : undefined);

  const ubicacionesValidas = () => {
    if (!geografiaTraslado.contexto?.configurada || String(geografiaTraslado.autorizacionId) !== String(form.getFieldValue('autorizacion_id'))) return false;
    return [['origen', ciudadesOrigen], ['destino', ciudadesDestino]].every(([lado, ciudades]) => {
      const departamento = resolverUbicacion(geografiaTraslado.filtrar(departamentos, 'departamento', lado), form.getFieldValue(`${lado}_departamento`));
      const ciudad = resolverUbicacion(geografiaTraslado.filtrar(ciudades, 'ciudad', lado), form.getFieldValue(`${lado}_ciudad`));
      return departamento && ciudad && Number(ciudad.departamento_id) === Number(departamento.id);
    });
  };
  const comprobarUbicaciones = () => {
    if (ubicacionesValidas()) return true;
    message.warning(geografiaTraslado.error || 'Seleccione departamentos y ciudades permitidos para el origen y el destino antes de programar.');
    return false;
  };

  // Cuando se abra el modal, cargo la lista de departamentos
  useEffect(() => {
    if (open) {
      fetchDepartamentos();
    }
  }, [open, fetchDepartamentos]);

  // Handlers para cambiar departamento
  const handleChangeOrigenDepartamento = (value) => {
    form.setFieldsValue({ origen_departamento: value, origen_ciudad: null });
  };

  const handleChangeDestinoDepartamento = (value) => {
    form.setFieldsValue({ destino_departamento: value, destino_ciudad: null });
  };

  // ===========================
  // == Funciones Auxiliares ==
  // ===========================
  const calculateAge = (fechaNacimiento) => {
    if (!fechaNacimiento) return "";
    const birthDate = dayjs(fechaNacimiento);
    const today = dayjs();
    let age = today.year() - birthDate.year();
    if (
      today.month() < birthDate.month() ||
      (today.month() === birthDate.month() && today.date() < birthDate.date())
    ) {
      age--;
    }
    return age;
  };

  // Función para calcular distancia usando fórmula de Haversine
  const calculateDistance = (lat1, lng1, lat2, lng2) => {
    if (!lat1 || !lng1 || !lat2 || !lng2) return null;
    
    const R = 6371; // Radio de la Tierra en kilómetros
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
      Math.sin(dLng/2) * Math.sin(dLng/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const distance = R * c;
    
    return Math.round(distance * 100) / 100; // Redondear a 2 decimales
  };

  // Función para calcular tiempo estimado basado en distancia
  const calculateEstimatedTime = (distanceKm) => {
    if (!distanceKm) return null;
    
    // Velocidad promedio en ciudad: 25 km/h
    // Velocidad promedio en carretera: 60 km/h
    // Usaremos una velocidad promedio ponderada de 35 km/h
    const avgSpeedKmH = 35;
    const timeHours = distanceKm / avgSpeedKmH;
    const timeMinutes = Math.round(timeHours * 60);
    
    // Formatear tiempo en horas y minutos
    if (timeMinutes < 60) {
      return `${timeMinutes} min`;
    } else {
      const hours = Math.floor(timeMinutes / 60);
      const minutes = timeMinutes % 60;
      return minutes > 0 ? `${hours}h ${minutes}min` : `${hours}h`;
    }
  };

  // Función para convertir tiempo formateado de vuelta a minutos (para DB)
  const convertFormattedTimeToMinutes = (formattedTime) => {
    if (!formattedTime || typeof formattedTime !== 'string') return 0;
    
    // Extraer números del string formateado
    const minMatch = formattedTime.match(/(\d+)\s*min/);
    const hourMatch = formattedTime.match(/(\d+)h/);
    
    let totalMinutes = 0;
    
    if (hourMatch) {
      totalMinutes += parseInt(hourMatch[1]) * 60;
    }
    
    if (minMatch) {
      totalMinutes += parseInt(minMatch[1]);
    }
    
    return totalMinutes;
  };

  // Función para parsear coordenadas desde string "lat, lng"
  const parseCoordinates = (coordString) => {
    if (!coordString || typeof coordString !== 'string') return null;
    
    const coords = coordString.split(',').map(coord => coord.trim());
    if (coords.length !== 2) return null;
    
    const lat = parseFloat(coords[0]);
    const lng = parseFloat(coords[1]);
    
    if (isNaN(lat) || isNaN(lng)) return null;
    
    return { lat, lng };
  };

  // Función para calcular automáticamente distancia y tiempo
  const calculateDistanceAndTime = (origenCoords, destinoCoords) => {
    const origen = parseCoordinates(origenCoords);
    const destino = parseCoordinates(destinoCoords);
    
    if (!origen || !destino) {
      setCalculatedDistance(null);
      setCalculatedDuration(null);
      // Limpiar campos del formulario
      form.setFieldsValue({
        distancia_km: null,
        tiempo_estimado: null
      });
      return;
    }
    
    const distance = calculateDistance(origen.lat, origen.lng, destino.lat, destino.lng);
    const duration = calculateEstimatedTime(distance);
    
    setCalculatedDistance(distance);
    setCalculatedDuration(duration);
    
    // Actualizar campos del formulario
    form.setFieldsValue({
      distancia_km: distance,
      tiempo_estimado: duration
    });
  };

  const resetFormFields = () => {
    // También limpiar estados calculados
    setCalculatedDistance(null);
    setCalculatedDuration(null);
    
    form.resetFields([
      "autorizacion_id",
      "geografia_version_esperada",
      "autorizacion",
      "preautorizacion",
      "tipo_autorizacion",
      "empresa",
      "proposito",
      "diagnostico_nombre",
      "copago",
      "tipo_traslado",
      "tipo_viaje",
      "traslados_restantes",
      "parentesco_responsable",
      "nombre_responsable",
      "numero_contacto_responsable",
      "origen_lugar",
      "origen_direccion",
      "origen_departamento",
      "origen_ciudad",
      "origen_localidad",
      "origen_barrio",
      "origen_vereda_corregimiento",
      "origen_indicaciones",
      "origen_coordenadas",
      "destino_lugar",
      "destino_direccion",
      "destino_departamento",
      "destino_ciudad",
      "destino_localidad",
      "destino_barrio",
      "destino_vereda_corregimiento",
      "destino_indicaciones",
      "destino_coordenadas",
      "distancia_km",
      "tiempo_estimado",
      "observaciones_autorizacion",
      "fecha",
      "hora_recogida",
      "hora_llegada",
      "hora_retorno_recogida",
      "hora_retorno_llegada",
    ]);
  };

  const fetchInstitucion = async (institucionId) => {
    try {
      const response = await api.get(`/instituciones/${institucionId}`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener institución:", error);
      throw error;
    }
  };

  // --> Auxiliar para actualizar con data de institución
  const updateFormWithInstitucionData = async (institucion, prefix) => {
    const {
      departamento_id,
      ciudad_id,
      direccion,
      coordenadas,
      indicaciones,
      barrio,
      localidad,
    } = institucion;

    form.setFieldsValue({
      [`${prefix}_departamento`]: departamento_id || "",
      [`${prefix}_ciudad`]: ciudad_id || "",
      [`${prefix}_direccion`]: direccion || "",
      [`${prefix}_barrio`]: barrio || "",
      [`${prefix}_localidad`]: localidad || "",
      [`${prefix}_indicaciones`]: indicaciones || "",
      [`${prefix}_coordenadas`]: formatCoordinates(coordenadas),
    });

    // Recalcular distancia y tiempo automáticamente después de actualizar institución
    setTimeout(() => {
      const origenCoords = form.getFieldValue('origen_coordenadas');
      const destinoCoords = form.getFieldValue('destino_coordenadas');
      if (origenCoords && destinoCoords) {
        calculateDistanceAndTime(origenCoords, destinoCoords);
      }
    }, 100);

  };

  // --> NUEVO: funciones para obtener nombres en vez de IDs
  const getDepartamentoName = (deptoId) => {
    const dep = departamentos.find((d) => d.id === deptoId);
    return dep ? dep.nombre : "";
  };

  const getCiudadName = (prefix, ciudadId) => {
    const listaCiudades =
      prefix === "origen" ? ciudadesOrigen : ciudadesDestino;
    const city = listaCiudades.find((c) => c.id === ciudadId);
    return city ? city.nombre : "";
  };

  const getInstitucionName = (valor, esTemporal) => {
    // Si es temporal, 'valor' es el texto ingresado
    if (esTemporal) return valor || "";
    // Si no, 'valor' es ID => buscar en instituciones
    const inst = instituciones.find((i) => i.id === valor);
    return inst ? inst.nombre : valor || "";
  };

  // ==============================
  // == Lista de Pacientes (Select)
  // ==============================
  const patientOptions = useMemo(() => {
    return (patients || []).map((patient) => {
      const estado = patient.estado_descripcion || "Desconocido";
      const color = estadoColors[estado] || "default";
      const nombre = patient.nombre || "Sin Nombre";
      const numeroDocumento = patient.numero_documento || "Sin Documento";

      return (
        <Option
          key={patient.id}
          value={patient.id}
          label={`${nombre} - ${numeroDocumento}`}
          disabled={estado !== "Activo"}
        >
          <span>
            {`${nombre} - ${numeroDocumento} `}
            <Tag color={color} style={{ marginLeft: 8 }}>
              {estado}
            </Tag>
          </span>
        </Option>
      );
    });
  }, [patients]);

  // ==============================
  // == Lista de Autorizaciones  ==
  // ==============================
  const autorizacionOptions = useMemo(() => {
    return (autorizaciones || []).map((a) => {
      const estadoAutorizacion =
        a.estado_autorizacion?.toLowerCase() || "default";
      const color = autorizacionEstadoColors[estadoAutorizacion] || "default";

      const tipoTraslado = a.tipo_traslado || "Sin tipo";

      const tipoLabels = [];
      if (a.numero_autorizacion) {
        tipoLabels.push(`AUT: ${a.numero_autorizacion}`);
      }
      if (a.numero_pre_autorizacion) {
        tipoLabels.push(`PRE: ${a.numero_pre_autorizacion}`);
      }
      const tipoLabel = tipoLabels.join(", ");

      const fechaInicio = a.inicio_fecha_autorizacion
        ? dayjs(a.inicio_fecha_autorizacion).format("DD/MM/YY")
        : "Sin Fecha Inicio";
      const fechaFin = a.final_fecha_autorizacion
        ? dayjs(a.final_fecha_autorizacion).format("DD/MM/YY")
        : "Sin Fecha Fin";

      const key =
        a.id || `${a.numero_autorizacion}-${a.numero_pre_autorizacion}`;

      return (
        <Option
          key={key}
          value={key}
          label={tipoLabel}
          disabled={estadoAutorizacion !== "activa"}
        >
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <span>{tipoLabel}</span>
              <div style={{ display: "flex" }}>
                <Tag color={color} style={{ marginLeft: 8 }}>
                  {estadoAutorizacion.charAt(0).toUpperCase() +
                    estadoAutorizacion.slice(1)}
                </Tag>
                <Tag style={{ marginLeft: 8 }}>{tipoTraslado}</Tag>
              </div>
            </div>
            <div style={{ fontSize: "12px", color: "#888" }}>
              {fechaInicio} - {fechaFin}
            </div>
          </div>
        </Option>
      );
    });
  }, [autorizaciones]);

  // Cargar datos completos del paciente
  const fetchPatientInfo = async (patientId) => {
    if (!patientId) return;
    try {
      const response = await api.get(`/pacientes/${patientId}`);
      if (Number(form.getFieldValue("paciente_id")) !== Number(patientId)) return;
      const patient = response.data;

      const calculatedAge = calculateAge(patient.fecha_nacimiento);

      const formValues = {
        nombre_paciente: patient.nombre,
        tipo_documento_paciente: patient.tipo_documento_descripcion || "",
        numero_documento_paciente: patient.numero_documento || "",
        tipo_usuario: patient.tipo_nombre || "",
        genero_paciente: patient.genero || "",
        numero_contacto_paciente: patient.telefono || "",
        zona_paciente: patient.zona_nombre || "",
        edad_paciente: calculatedAge,
      };

      form.setFieldsValue(formValues);

    } catch (error) {
      console.error("Error al obtener la información del paciente:", error);
    }
  };

  const fetchPatientAuthorizations = async (patientId) => {
    try {
      // Construir URL con filtro de TAI si se especifica
      let url = `/autorizaciones/paciente/${patientId}`;
      if (isTai !== null) {
        url += `?es_tai=${isTai}`;
      }
      const response = await api.get(url);
      if (Number(form.getFieldValue("paciente_id")) !== Number(patientId)) return;

      // Validar que la respuesta sea un array
      let autorizacionesData = [];
      if (Array.isArray(response.data)) {
        autorizacionesData = response.data;
      } else if (response.data && Array.isArray(response.data.rows)) {
        // Si la respuesta tiene estructura { rows: [...] }
        autorizacionesData = response.data.rows;
      } else if (response.data && Array.isArray(response.data.data)) {
        // Si la respuesta tiene estructura { data: [...] }
        autorizacionesData = response.data.data;
      } else {
        autorizacionesData = [];
      }

      setAutorizaciones(autorizacionesData);
    } catch (error) {
      console.error("Error al obtener autorizaciones:", error);
      if (Number(form.getFieldValue("paciente_id")) === Number(patientId)) setAutorizaciones([]);
    }
  };

  // ==============================
  // == Manejo del Select Paciente
  // ==============================
  const handlePatientChange = async (value) => {
    resetFormFields();
    setAutorizaciones([]);
    setMinFecha(null);
    setMaxFecha(null);
    setOrigin(null);
    setDestination(null);
    setSelectedDate(null);

    if (value) {
      await fetchPatientInfo(value);
      await fetchPatientAuthorizations(value);
    } else {
      form.resetFields();
      setAutorizaciones([]);
    }
  };

  // ====================================================
  // == Manejo de Autorizaciones en <Select>
  // ====================================================
  const formFieldMapping = {
    autorizacion_id: "id",
    autorizacion: "numero_autorizacion",
    preautorizacion: "numero_pre_autorizacion",
    tipo_autorizacion: "tipo_autorizacion",
    empresa: "empresa",
    nombre_paciente: "nombre_paciente",
    proposito: "proposito",
    diagnostico_nombre: "diagnostico_nombre",
    copago: "copago",
    tipo_traslado: "tipo_traslado",
    tipo_viaje: "tipo_viaje",
    traslados_restantes: "traslados_restantes",
    parentesco_responsable: "parentesco_responsable",
    nombre_responsable: "nombre_responsable",
    numero_contacto_responsable: "telefono_responsable",
    origen_lugar: "origen_institucion",
    origen_direccion: "origen_direccion",
    origen_departamento: "origen_departamento",
    origen_ciudad: "origen_ciudad",
    origen_localidad: "origen_localidad",
    origen_barrio: "origen_barrio",
    origen_vereda_corregimiento: "origen_vereda_corregimiento",
    origen_indicaciones: "origen_indicaciones",
    origen_coordenadas: "origen_coordenadas",
    destino_lugar: "destino_institucion",
    destino_direccion: "destino_direccion",
    destino_departamento: "destino_departamento",
    destino_ciudad: "destino_ciudad",
    destino_localidad: "destino_localidad",
    destino_barrio: "destino_barrio",
    destino_vereda_corregimiento: "destino_vereda_corregimiento",
    destino_indicaciones: "destino_indicaciones",
    destino_coordenadas: "destino_coordenadas",
    observaciones_autorizacion: "observaciones",
  };

  const findSelectedAutorizacion = (autorizaciones, value) => {
    return autorizaciones.find(
      (a) =>
        (a.id || `${a.numero_autorizacion}-${a.numero_pre_autorizacion}`) ===
        value
    );
  };

  const parseDateToDayjs = (dateString) => {
    return dateString ? dayjs(dateString, "YYYY-MM-DD") : null;
  };

  const determineSelectedDate = (inicio, fin) => {
    const today = dayjs();
    if (inicio && fin && today.isBetween(inicio, fin, null, "[]")) {
      return today;
    }
    return inicio;
  };

  const processDates = (selectedAutorizacion) => {
    const inicio = parseDateToDayjs(
      selectedAutorizacion.inicio_fecha_autorizacion
    );
    const fin = parseDateToDayjs(selectedAutorizacion.final_fecha_autorizacion);
    const selectedDateLocal = determineSelectedDate(inicio, fin);
    return { inicio, fin, selectedDate: selectedDateLocal };
  };

  const formatCoordinates = (coordinates) => {
    // Manejar diferentes formatos de coordenadas
    if (!coordinates) return "";
    
    // Si ya es string, devolverlo tal como está
    if (typeof coordinates === 'string') {
      return coordinates;
    }
    
    // Si es objeto GeoJSON, convertir a string
    if (typeof coordinates === 'object' && coordinates.type === 'Point') {
      return geoJsonToString(coordinates);
    }
    
    // Si es objeto con propiedad coordinates, convertir a string
    if (typeof coordinates === 'object' && coordinates.coordinates) {
      return geoJsonToString(coordinates);
    }
    
    return "";
  };

  const getFormValues = (selectedAutorizacion) => {
    const formValues = {};
    Object.entries(formFieldMapping).forEach(([formKey, authKey]) => {
      if (authKey.includes("coordenadas")) {
        formValues[formKey] = formatCoordinates(selectedAutorizacion[authKey]);
      } else if (formKey === "origen_lugar") {
        // Priorizar lugar temporal sobre institución normal para origen
        formValues[formKey] = selectedAutorizacion.origen_lugar_temporal || selectedAutorizacion.origen_institucion || "";
      } else if (formKey === "destino_lugar") {
        // Priorizar lugar temporal sobre institución normal para destino
        formValues[formKey] = selectedAutorizacion.destino_lugar_temporal || selectedAutorizacion.destino_institucion || "";
      } else {
        formValues[formKey] = selectedAutorizacion[authKey] || "";
      }
    });
    return formValues;
  };

  const handleAutorizacionChange = (value) => {
    if (!value) {
      resetFormFields();
      setMinFecha(null);
      setMaxFecha(null);
      setOrigin(null);
      setDestination(null);
      setSelectedDate(null);
      setTipoAutorizacion(null);
      setCalendarioAutorizacion([]);
      return;
    }

    const selectedAutorizacion = findSelectedAutorizacion(
      autorizaciones,
      value
    );
    if (!selectedAutorizacion) return;

    // Guardar tipo de autorización y calendario para validación de fechas
    setTipoAutorizacion(selectedAutorizacion.tipo_autorizacion?.toLowerCase());
    // Parsear calendario si es string JSON
    let calendario = selectedAutorizacion.calendario || [];
    if (typeof calendario === 'string') {
      try {
        calendario = JSON.parse(calendario);
      } catch (e) {
        calendario = [];
      }
    }
    setCalendarioAutorizacion(Array.isArray(calendario) ? calendario : []);

    const {
      inicio,
      fin,
      selectedDate: newSelectedDate,
    } = processDates(selectedAutorizacion);

    setMinFecha(inicio);
    setMaxFecha(fin);

    const formValues = getFormValues(selectedAutorizacion);
    
    // Determinar si origen y destino son temporales
    const origenEsTemporalFlag = !!(selectedAutorizacion.origen_lugar_temporal && selectedAutorizacion.origen_lugar_temporal.trim());
    const destinoEsTemporalFlag = !!(selectedAutorizacion.destino_lugar_temporal && selectedAutorizacion.destino_lugar_temporal.trim());
    
    setOrigenEsTemporal(origenEsTemporalFlag);
    setDestinoEsTemporal(destinoEsTemporalFlag);
    
    form.setFieldsValue({ ...formValues, fecha: newSelectedDate });
    setSelectedDate(newSelectedDate);

    // Refrescar datos de IPS desde la base de datos para asegurar direcciones actualizadas
    // Esto es necesario porque la autorización puede tener datos desactualizados
    const refreshInstitucionData = async () => {
      try {
        // Refrescar datos de destino si es una IPS válida (no temporal)
        if (!destinoEsTemporalFlag && selectedAutorizacion.destino_institucion) {
          const destinoInst = instituciones.find(
            (i) => i.nombre.toLowerCase() === selectedAutorizacion.destino_institucion.toLowerCase()
          );
          if (destinoInst && destinoInst.nombre.toLowerCase() !== "sin destino") {
            form.setFieldsValue({ destino_lugar: destinoInst.id });
            const instData = await fetchInstitucion(destinoInst.id);
            if (Number(form.getFieldValue("autorizacion_id")) !== Number(selectedAutorizacion.id) ||
                form.getFieldValue("destino_lugar") !== destinoInst.id) return;
            await updateFormWithInstitucionData(instData, "destino");
          }
        }

        // Refrescar datos de origen si es una IPS válida (no temporal)
        if (!origenEsTemporalFlag && selectedAutorizacion.origen_institucion) {
          const origenInst = instituciones.find(
            (i) => i.nombre.toLowerCase() === selectedAutorizacion.origen_institucion.toLowerCase()
          );
          if (origenInst && origenInst.nombre.toLowerCase() !== "sin destino") {
            form.setFieldsValue({ origen_lugar: origenInst.id });
            const instData = await fetchInstitucion(origenInst.id);
            if (Number(form.getFieldValue("autorizacion_id")) !== Number(selectedAutorizacion.id) ||
                form.getFieldValue("origen_lugar") !== origenInst.id) return;
            await updateFormWithInstitucionData(instData, "origen");
          }
        }
      } catch (error) {
        console.error("Error al refrescar datos de instituciones:", error);
      }
    };
    refreshInstitucionData();

    // Calcular automáticamente distancia y tiempo cuando hay coordenadas
    setTimeout(() => {
      const origenCoords = form.getFieldValue('origen_coordenadas');
      const destinoCoords = form.getFieldValue('destino_coordenadas');
      if (origenCoords && destinoCoords) {
        calculateDistanceAndTime(origenCoords, destinoCoords);
      }
    }, 100);
  };

  // ==========================
  // == Botón Swap Origen <-> Destino
  // ==========================
  const swapOrigenDestino = () => {
    const contextoActual = String(geografiaTraslado.autorizacionId) === String(form.getFieldValue('autorizacion_id'))
      ? geografiaTraslado.contexto : null;
    const motivo = motivoIntercambio(form.getFieldsValue(true), contextoActual, departamentos, ciudadesOrigen, ciudadesDestino);
    if (motivo) {
      message.warning(motivo);
      return;
    }
    const origen = {
      lugar: form.getFieldValue("origen_lugar"),
      direccion: form.getFieldValue("origen_direccion"),
      departamento: form.getFieldValue("origen_departamento"),
      ciudad: form.getFieldValue("origen_ciudad"),
      localidad: form.getFieldValue("origen_localidad"),
      barrio: form.getFieldValue("origen_barrio"),
      vereda_corregimiento: form.getFieldValue("origen_vereda_corregimiento"),
      indicaciones: form.getFieldValue("origen_indicaciones"),
      coordenadas: form.getFieldValue("origen_coordenadas"),
    };

    const destino = {
      lugar: form.getFieldValue("destino_lugar"),
      direccion: form.getFieldValue("destino_direccion"),
      departamento: form.getFieldValue("destino_departamento"),
      ciudad: form.getFieldValue("destino_ciudad"),
      localidad: form.getFieldValue("destino_localidad"),
      barrio: form.getFieldValue("destino_barrio"),
      vereda_corregimiento: form.getFieldValue("destino_vereda_corregimiento"),
      indicaciones: form.getFieldValue("destino_indicaciones"),
      coordenadas: form.getFieldValue("destino_coordenadas"),
    };

    form.setFieldsValue({
      origen_lugar: destino.lugar,
      origen_direccion: destino.direccion,
      origen_departamento: destino.departamento,
      origen_ciudad: destino.ciudad,
      origen_localidad: destino.localidad,
      origen_barrio: destino.barrio,
      origen_vereda_corregimiento: destino.vereda_corregimiento,
      origen_indicaciones: destino.indicaciones,
      origen_coordenadas: destino.coordenadas,

      destino_lugar: origen.lugar,
      destino_direccion: origen.direccion,
      destino_departamento: origen.departamento,
      destino_ciudad: origen.ciudad,
      destino_localidad: origen.localidad,
      destino_barrio: origen.barrio,
      destino_vereda_corregimiento: origen.vereda_corregimiento,
      destino_indicaciones: origen.indicaciones,
      destino_coordenadas: origen.coordenadas,
    });

    // Las ciudades se cargan según los departamentos intercambiados.

    setOrigenEsTemporal(destinoEsTemporal);
    setDestinoEsTemporal(origenEsTemporal);

    // Recalcular distancia y tiempo después del intercambio
    setTimeout(() => {
      if (destino.coordenadas && origen.coordenadas) {
        calculateDistanceAndTime(destino.coordenadas, origen.coordenadas);
      }
      form.validateFields().catch(() => {});
    }, 100);
  };

  // ======================
  // == Lógica Agendar
  // ======================
  const validarEstadoAgendar = useCallback(() => {
    const fecha = form.getFieldValue("fecha");
    const horaRecogida = form.getFieldValue("hora_recogida");
    const horaLlegada = form.getFieldValue("hora_llegada");
    const horaRetornoRecogida = form.getFieldValue("hora_retorno_recogida");
    const horaRetornoLlegada = form.getFieldValue("hora_retorno_llegada");

    const horasCorrectas =
      (horaRecogida && horaLlegada) ||
      (horaRetornoRecogida && horaRetornoLlegada);

    const esFechaSeleccionada = fecha?.isValid();
    setIsAgendarDisabled(esFechaSeleccionada || !horasCorrectas);
  }, [form]);

  useEffect(() => {
    validarEstadoAgendar();
  }, [validarEstadoAgendar]);

  const handleTimeChange = () => {
    validarEstadoAgendar();
    // Revalidar todos los campos de hora para asegurar consistencia cruzada
    form.validateFields([
      "hora_recogida",
      "hora_llegada",
      "hora_retorno_recogida",
      "hora_retorno_llegada",
    ]).catch(() => {
      // Ignorar errores de validación aquí, se mostrarán en los campos
    });
  };

  const isAtLeast15MinutesAfter = (earlier, later) => {
    if (!earlier || !later) return true;
    return later.diff(earlier, "minute") >= 15;
  };

  useEffect(() => {
    if (initialPacienteId) {
      // Si hay un paciente inicial, cargar sus datos
      fetchPatientInfo(initialPacienteId);
      fetchPatientAuthorizations(initialPacienteId);
      
      // Establecer el valor en el formulario
      form.setFieldsValue({ paciente_id: initialPacienteId });
    }
  }, [initialPacienteId]);

  useEffect(() => {
    if (initialAutorizacionId && autorizaciones.length > 0) {
      // Buscar la autorización en la lista cargada
      const selectedAuth = autorizaciones.find(auth => 
        auth.id === initialAutorizacionId || 
        auth.numero_autorizacion === initialAutorizacionId
      );
      
      if (selectedAuth) {
        const authValue = selectedAuth.id || `${selectedAuth.numero_autorizacion}-${selectedAuth.numero_pre_autorizacion}`;
        form.setFieldsValue({ autorizacion: authValue });
        handleAutorizacionChange(authValue);
      }
    }
  }, [initialAutorizacionId, autorizaciones]);
  // ================================
  // == onFinish => Guardar Traslados
  // ================================
  const onFinish = async (values) => {
    if (!comprobarUbicaciones()) return;
    const seleccion = trayectosSeleccionados(values);
    if (!seleccion.valido) { message.error('Complete las dos horas de ida, las dos de retorno o ambas parejas.'); return; }
    setShowLoading(true);
    message.loading({
      content: "Programando traslados...",
      key: "load-traslado",
      duration: 0,
    });
    try {
      if (maxFecha && dayjs().isAfter(maxFecha.endOf("day"))) {
        message.error("No se puede programar: la autorización está vencida");
        return;
      }

      const destinoLugarId = form.getFieldValue("destino_lugar");
      const realDestinoLugar = getInstitucionName(
        destinoLugarId,
        destinoEsTemporal
      );

      if (realDestinoLugar.trim().toLowerCase() === "sin destino") {
        message.error(
          "No se puede programar un traslado cuando la institución destino es 'Sin Destino'."
        );
        return;
      }

      const origenLugarId = form.getFieldValue("origen_lugar");
      const realOrigenLugar = getInstitucionName(
        origenLugarId,
        origenEsTemporal
      );

      if (realOrigenLugar.trim().toLowerCase() === "sin destino") {
        message.error(
          "No se puede programar un traslado cuando la institución origen es 'Sin Destino'."
        );
        return;
      }

      const usuario_id = user.id;
      const traslados = [];

      // Obtener coordenadas - el formato del input es "latitude, longitude"
      const origenCoords = form
        .getFieldValue("origen_coordenadas")
        ?.split(",")
        .map((coord) => parseFloat(coord.trim())) || [0, 0];
      const destinoCoords = form
        .getFieldValue("destino_coordenadas")
        ?.split(",")
        .map((coord) => parseFloat(coord.trim())) || [0, 0];

      // Obtener nombres para origen
      const origen_departamento_id = form.getFieldValue("origen_departamento");
      const origen_ciudad_id = form.getFieldValue("origen_ciudad");
      const origenDepartamentoName = getDepartamentoName(
        origen_departamento_id
      );
      const origenCiudadName = getCiudadName("origen", origen_ciudad_id);

      // Obtener nombres para destino
      const destino_departamento_id = form.getFieldValue(
        "destino_departamento"
      );
      const destino_ciudad_id = form.getFieldValue("destino_ciudad");
      const destinoDepartamentoName = getDepartamentoName(
        destino_departamento_id
      );
      const destinoCiudadName = getCiudadName("destino", destino_ciudad_id);

      // Creamos el objeto "ida"
      const trasladoIda = {
        ...tiposLugar(form),
        usuario_id,
        autorizacion_id: values.autorizacion_id,
        paciente_id: values.paciente_id,
        nombre_paciente: form.getFieldValue("nombre_paciente"),
        tipo_usuario: form.getFieldValue("tipo_usuario"),
        tipo_documento_paciente: form.getFieldValue("tipo_documento_paciente"),
        numero_documento_paciente: form.getFieldValue(
          "numero_documento_paciente"
        ),
        genero_paciente: form.getFieldValue("genero_paciente"),
        numero_contacto_paciente: form.getFieldValue(
          "numero_contacto_paciente"
        ),
        parentesco_responsable: form.getFieldValue("parentesco_responsable"),
        nombre_responsable: form.getFieldValue("nombre_responsable"),
        numero_contacto_responsable: form.getFieldValue(
          "numero_contacto_responsable"
        ),
        empresa: form.getFieldValue("empresa"),
        preautorizacion: form.getFieldValue("preautorizacion"),
        autorizacion: form.getFieldValue("autorizacion"),
        proposito: form.getFieldValue("proposito"),
        diagnostico_nombre: form.getFieldValue("diagnostico_nombre"),
        copago: form.getFieldValue("copago"),
        tipo_traslado: form.getFieldValue("tipo_traslado"),
        tipo_viaje: form.getFieldValue("tipo_viaje"),
        trayecto: "Ida",
        tipo_autorizacion: form.getFieldValue("tipo_autorizacion"),
        observaciones_autorizacion: form.getFieldValue(
          "observaciones_autorizacion"
        ),
        observaciones_traslado: values.observaciones_traslado || "",
        indicaciones_conductor: values.indicaciones_conductor || "",
        fecha: values.fecha.format("YYYY-MM-DD"),
        hora_recogida: values.hora_recogida?.format("HH:mm"),
        hora_llegada: values.hora_llegada?.format("HH:mm"),
        duracion_estimada: convertFormattedTimeToMinutes(calculatedDuration) || 0,
        distancia_estimada: calculatedDistance || 0,
        vehiculo_id: null,
        conductor_id: null,
        status: "Programado",
        seguimiento: "Sin Validar",
        zona_paciente: form.getFieldValue("zona_paciente"),

        // ORIGEN con nombres
        origen_lugar: realOrigenLugar,
        origen_direccion: form.getFieldValue("origen_direccion"),
        origen_departamento: origenDepartamentoName,
        origen_ciudad: origenCiudadName,
        origen_localidad: form.getFieldValue("origen_localidad"),
        origen_barrio: form.getFieldValue("origen_barrio"),
        origen_vereda_corregimiento: form.getFieldValue("origen_vereda_corregimiento"),
        origen_indicaciones: form.getFieldValue("origen_indicaciones"),
        origen_coordenadas: {
          type: "Point",
          coordinates: [origenCoords[0], origenCoords[1]],
        },

        // DESTINO con nombres
        destino_lugar: realDestinoLugar,
        destino_direccion: form.getFieldValue("destino_direccion"),
        destino_departamento: destinoDepartamentoName,
        destino_ciudad: destinoCiudadName,
        destino_localidad: form.getFieldValue("destino_localidad"),
        destino_barrio: form.getFieldValue("destino_barrio"),
        destino_vereda_corregimiento: form.getFieldValue("destino_vereda_corregimiento"),
        destino_indicaciones: form.getFieldValue("destino_indicaciones"),
        destino_coordenadas: {
          type: "Point",
          coordinates: [destinoCoords[0], destinoCoords[1]],
        },
      };
      if (seleccion.ida) traslados.push(trasladoIda);

      // Si hay horas de retorno => "Retorno"
      if (seleccion.retorno) {
        const trasladoRetorno = {
          ...trasladoIda,
          ...invertirTipos(trasladoIda),
          trayecto: "Retorno",
          hora_recogida: values.hora_retorno_recogida.format("HH:mm"),
          hora_llegada: values.hora_retorno_llegada.format("HH:mm"),
          duracion_estimada: convertFormattedTimeToMinutes(calculatedDuration) || 0,
          distancia_estimada: calculatedDistance || 0,
          // Invertir Origen <-> Destino, pero usando NOMBRES
          origen_lugar: realDestinoLugar,
          origen_direccion: form.getFieldValue("destino_direccion"),
          origen_departamento: destinoDepartamentoName,
          origen_ciudad: destinoCiudadName,
          origen_localidad: form.getFieldValue("destino_localidad"),
          origen_barrio: form.getFieldValue("destino_barrio"),
          origen_vereda_corregimiento: form.getFieldValue("destino_vereda_corregimiento"),
          origen_indicaciones: form.getFieldValue("destino_indicaciones"),
          origen_coordenadas: {
            type: "Point",
            coordinates: [destinoCoords[0], destinoCoords[1]],
          },
          destino_lugar: realOrigenLugar,
          destino_direccion: form.getFieldValue("origen_direccion"),
          destino_departamento: origenDepartamentoName,
          destino_ciudad: origenCiudadName,
          destino_localidad: form.getFieldValue("origen_localidad"),
          destino_barrio: form.getFieldValue("origen_barrio"),
          destino_vereda_corregimiento: form.getFieldValue("origen_vereda_corregimiento"),
          destino_indicaciones: form.getFieldValue("origen_indicaciones"),
          destino_coordenadas: {
            type: "Point",
            coordinates: [origenCoords[0], origenCoords[1]],
          },
          copago: 0,
          copago_diario: 0,
        };
        traslados.push(trasladoRetorno);
      }

      // Guardar en la API
      await guardarLote(traslados);

      message.success({
        content: "Traslados guardados exitosamente.",
        key: "load-traslado",
        duration: 2,
      });
      onSubmit();
      onClose();
    } catch (error) {
      console.error("Error al guardar traslados:", error);
      // Extraer mensaje de error del backend
      const errorMessage = error.response?.data?.error
        || error.response?.data?.message
        || error.message
        || "Ocurrió un error al guardar los traslados.";
      message.error({
        content: errorMessage,
        key: "load-traslado",
        duration: 5,
      });
    } finally {
      setShowLoading(false);
    }
  };

  const checkSinDestino = useCallback(() => {
  const origenLugarId = form.getFieldValue("origen_lugar");
  const destinoLugarId = form.getFieldValue("destino_lugar");
  
  const realOrigenLugar = getInstitucionName(origenLugarId, origenEsTemporal);
  const realDestinoLugar = getInstitucionName(destinoLugarId, destinoEsTemporal);

  return (
    realOrigenLugar.trim().toLowerCase() === "sin destino" ||
    realDestinoLugar.trim().toLowerCase() === "sin destino"
  );
}, [form, origenEsTemporal, destinoEsTemporal, getInstitucionName]);

  // =========================
  // == Ver ruta en el Mapa
  // =========================
  const handleOpenMap = () => {
    if (origin && destination) {
      setMapMode(null);
      setMapVisible(true);
    } else {
      message.error("Coordenadas no válidas. Por favor verifique los datos.");
    }
  };

  const handleCloseMap = () => {
    setMapVisible(false);
  };

  // ============================
  // == Manejo de Agendar
  // ============================
  const handleAgendarClick = () => {
    if (!comprobarUbicaciones()) return;
    setIsAgendarVisible(true);
  };

  const fetchTraslados = async () => {
    try {
      await api.get("/traslados");
    } catch (error) {
      console.error("Error al obtener traslados:", error);
    }
  };

  const handleAgendarClose = () => {
    setIsAgendarVisible(false);
    fetchTraslados();
    onSubmit();
  };

  // ======================
  // == Helpers TimePicker
  // ======================
  const disabledTimeFunc = useCallback(
    (current) => {
      // Usar hora del servidor para validaciones
      const serverNow = getServerTime();
      if (selectedDate?.isSame(serverNow, "day")) {
        const currentHour = serverNow.hour();
        const currentMinute = serverNow.minute();

        return {
          disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
          disabledMinutes: (selectedHour) => {
            if (selectedHour === currentHour) {
              return Array.from({ length: currentMinute }, (_, i) => i);
            }
            return [];
          },
          disabledSeconds: () => [],
        };
      }
      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
        disabledSeconds: () => [],
      };
    },
    [selectedDate, getServerTime]
  );


  const disabledDate = (current) => {
    if (!current || !maxFecha) return true;
    // Usar hora del servidor para validaciones
    const today = getServerTime().startOf("day");

    // Validar que la fecha esté dentro del rango de la autorización
    if (minFecha && current < minFecha.startOf("day")) {
      return true; // Deshabilitar fechas anteriores al inicio de la autorización
    }

    // Si está fuera del rango general, deshabilitar
    if (current < today || current > maxFecha.endOf("day")) {
      return true;
    }

    // Para autorizaciones cerradas, solo permitir fechas del calendario
    if (tipoAutorizacion === 'cerrada' && calendarioAutorizacion.length > 0) {
      const currentStr = current.format('YYYY-MM-DD');
      // Deshabilitar si la fecha NO está en el calendario
      return !calendarioAutorizacion.includes(currentStr);
    }

    return false;
  };

  // =================================
  // == Helpers para Select Lugares
  // =================================
  const noExisteInstitucion = (texto, lista) => {
    if (!texto) return false;
    const textoLower = texto.toLowerCase();
    return !lista.some((inst) => inst.nombre?.toLowerCase() === textoLower);
  };

  const renderDropdownMenu = (menu, searchText, lista, onAddLugarTemporal) => (
    <>
      {menu}
      {noExisteInstitucion(searchText, lista) && searchText.trim() !== "" && (
        <Button
          type="text"
          icon={<PlusOutlined style={{ marginRight: 8 }} />}
          onClick={() => onAddLugarTemporal(searchText)}
          style={{
            padding: "8px 12px",
            cursor: "pointer",
            borderTop: "1px solid #eee",
            display: "flex",
            alignItems: "center",
            color: "#1890ff",
            width: "100%",
            textAlign: "left",
          }}
        >
          Agregar lugar temporal: <strong>{searchText}</strong>
        </Button>
      )}
    </>
  );

  const handleAgregarLugarTemporalOrigen = async (textoBuscado) => {
    setOrigenEsTemporal(true);
    form.setFieldsValue({
      origen_lugar: textoBuscado,
      origen_departamento: "",
      origen_ciudad: "",
      origen_localidad: "",
      origen_barrio: "",
      origen_direccion: "",
      origen_indicaciones: "",
      origen_coordenadas: "",
    });
    // Cerrar el dropdown después de agregar lugar temporal
    setOrigenSelectOpen(false);
    setSearchTextOrigen("");
  };

  const handleAgregarLugarTemporalDestino = async (textoBuscado) => {
    setDestinoEsTemporal(true);
    form.setFieldsValue({
      destino_lugar: textoBuscado,
      destino_departamento: "",
      destino_ciudad: "",
      destino_localidad: "",
      destino_barrio: "",
      destino_direccion: "",
      destino_indicaciones: "",
      destino_coordenadas: "",
    });
    // Cerrar el dropdown después de agregar lugar temporal
    setDestinoSelectOpen(false);
    setSearchTextDestino("");
  };

  const handleOrigenChange = async (value) => {
    if (value === 'Domicilio') {
      const domicilio = geografiaTraslado.domicilio?.('origen');
      if (!domicilio) return;
      setOrigenEsTemporal(false);
      setOrigenSelectOpen(false);
      setSearchTextOrigen('');
      form.setFieldsValue({ origen_lugar: 'Domicilio', origen_tipo_lugar: 'domicilio', origen_institucion_id: null,
        origen_vereda_corregimiento: domicilio.vereda_corregimiento || '' });
      await updateFormWithInstitucionData(domicilio, 'origen');
      return;
    }
    if (!value) {
      setOrigenEsTemporal(false);
      form.setFieldsValue({
        origen_lugar: "",
        origen_departamento: "",
        origen_ciudad: "",
        origen_localidad: "",
        origen_barrio: "",
        origen_direccion: "",
        origen_indicaciones: "",
        origen_coordenadas: "",
      });
      // Limpiar cálculos cuando se elimina el origen
      setCalculatedDistance(null);
      setCalculatedDuration(null);
      form.setFieldsValue({
        distancia_km: null,
        tiempo_estimado: null
      });
      return;
    }
    const instEncontrada = instituciones.find((i) => i.id === value);
    if (instEncontrada) {
      setOrigenEsTemporal(false);
      form.setFieldsValue({ origen_lugar: instEncontrada.id });
      try {
        const autorizacionActual = form.getFieldValue("autorizacion_id");
        const instData = await fetchInstitucion(instEncontrada.id);
        if (form.getFieldValue("autorizacion_id") !== autorizacionActual ||
            form.getFieldValue("origen_lugar") !== instEncontrada.id) return;
        await updateFormWithInstitucionData(instData, "origen");
      } catch (error) {
        // Manejo error
      }
    } else {
      setOrigenEsTemporal(true);
      form.setFieldsValue({
        origen_lugar: value,
        origen_departamento: "",
        origen_ciudad: "",
        origen_localidad: "",
        origen_barrio: "",
        origen_direccion: "",
        origen_indicaciones: "",
        origen_coordenadas: "",
      });
      // Limpiar cálculos al seleccionar lugar temporal (sin coordenadas)
      setCalculatedDistance(null);
      setCalculatedDuration(null);
      form.setFieldsValue({
        distancia_km: null,
        tiempo_estimado: null
      });
    }
  };

  const handleDestinoChange = async (value) => {
    if (value === 'Domicilio') {
      const domicilio = geografiaTraslado.domicilio?.('destino');
      if (!domicilio) return;
      setDestinoEsTemporal(false);
      setDestinoSelectOpen(false);
      setSearchTextDestino('');
      form.setFieldsValue({ destino_lugar: 'Domicilio', destino_tipo_lugar: 'domicilio', destino_institucion_id: null,
        destino_vereda_corregimiento: domicilio.vereda_corregimiento || '' });
      await updateFormWithInstitucionData(domicilio, 'destino');
      return;
    }
    if (!value) {
      setDestinoEsTemporal(false);
      form.setFieldsValue({
        destino_lugar: "",
        destino_departamento: "",
        destino_ciudad: "",
        destino_localidad: "",
        destino_barrio: "",
        destino_direccion: "",
        destino_indicaciones: "",
        destino_coordenadas: "",
      });
      // Limpiar cálculos cuando se elimina el destino
      setCalculatedDistance(null);
      setCalculatedDuration(null);
      form.setFieldsValue({
        distancia_km: null,
        tiempo_estimado: null
      });
      return;
    }

    const instEncontrada = instituciones.find((i) => i.id === value);
    if (instEncontrada) {
      setDestinoEsTemporal(false);
      form.setFieldsValue({ destino_lugar: instEncontrada.id });
      try {
        const autorizacionActual = form.getFieldValue("autorizacion_id");
        const instData = await fetchInstitucion(instEncontrada.id);
        if (form.getFieldValue("autorizacion_id") !== autorizacionActual ||
            form.getFieldValue("destino_lugar") !== instEncontrada.id) return;
        await updateFormWithInstitucionData(instData, "destino");
      } catch (error) {
        // Manejo error
      }
    } else {
      setDestinoEsTemporal(true);
      form.setFieldsValue({
        destino_lugar: value,
        destino_departamento: "",
        destino_ciudad: "",
        destino_localidad: "",
        destino_barrio: "",
        destino_direccion: "",
        destino_indicaciones: "",
        destino_coordenadas: "",
      });
      // Limpiar cálculos al seleccionar lugar temporal (sin coordenadas)
      setCalculatedDistance(null);
      setCalculatedDuration(null);
      form.setFieldsValue({
        distancia_km: null,
        tiempo_estimado: null
      });
    }
  };

  const handleMapSelect = async (direccionMap, localidadMap, coordsMap, details) => {
    if (!['origen', 'destino'].includes(mapMode)) return false;
    const match = details?.catalog_match;
    if (match && !geografiaTraslado.filtrar([match.city], 'ciudad', mapMode).length) {
      message.warning('El municipio de la ubicación no está permitido para este recorrido.');
      return false;
    }
    form.setFieldsValue({
      ...selectedLocationFields(direccionMap, localidadMap, coordsMap, details, `${mapMode}_`),
      ...municipalityFields(details, `${mapMode}_`, false),
    });
    // Recalcular distancia y tiempo automáticamente después de seleccionar en el mapa
    setTimeout(() => {
      const origenCoords = form.getFieldValue('origen_coordenadas');
      const destinoCoords = form.getFieldValue('destino_coordenadas');
      if (origenCoords && destinoCoords) {
        calculateDistanceAndTime(origenCoords, destinoCoords);
      }
    }, 100);
  };

  return (
    <>
      <Modal
        open={open}
        onCancel={onClose}
        title={
          <div className="traslado-modal-header">
            Nueva Programación de Traslado
          </div>
        }
        confirmLoading={showLoading}
        footer={
          showLoading
            ? null
            : [
                <Button
                  key="agendar"
                  type="default"
                  onClick={handleAgendarClick}
                  disabled={isAgendarDisabled || showLoading || checkSinDestino() || !ubicacionesValidas()}
                  className="traslado-button agendar-button"
                >
                  Agendar
                </Button>,
                <Button
                  key="cancel"
                  onClick={onClose}
                  className="traslado-button cancelar-button"
                  disabled={showLoading}
                >
                  Cancelar
                </Button>,

                <Button
                  type="primary"
                  key="submit"
                  onClick={() => {
                    if (checkSinDestino()) {
                      message.error("No se puede programar con origen o destino 'Sin Destino'");
                      return;
                    }
                    if (maxFecha && dayjs().isAfter(maxFecha.endOf("day"))) {
                      message.error("Verifique: la autorización está vencida");
                      return;
                    }
                    form
                      .validateFields()
                      .then(() => form.submit())
                      .catch(() =>
                        message.error("Complete los campos requeridos")
                      );
                  }}
                  loading={showLoading}
                  disabled={showLoading || checkSinDestino() || !selectedDate || !ubicacionesValidas()}
                >
                  Programar
                </Button>,
              ]
        }
        width="90%"
        centered
        destroyOnHidden
        className="traslado-modal"
      >
        {/* Spinner */}
        {showLoading && (
          <Spin
            size="large"
            tip="Programando traslados..."
            className="custom-spin"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
          >
            <div style={{ opacity: 0.5, pointerEvents: "none" }}></div>
          </Spin>
        )}
        <div className="traslado-modal-content">
          {!showLoading && (
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              onValuesChange={(changedValues) => {
                if (changedValues.fecha !== undefined) {
                  setSelectedDate(changedValues.fecha);
                }
                validarEstadoAgendar();
              }}
            >
              {/* 1) Paciente y Autorización */}
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <Title level={4} className="traslado-section-title">
                    <UserOutlined className="traslado-section-icon" />
                    Seleccione Paciente
                  </Title>

                  <Form.Item
                    name="paciente_id"
                    label="Paciente"
                    rules={[
                      { required: true, message: "Seleccione un paciente" },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Seleccione un paciente"
                      onChange={handlePatientChange}
                      optionFilterProp="label"
                      className="traslado-select"
                      style={{ width: "100%" }}
                      filterOption={(input, option) => {
                        const label = option.label
                          ? option.label.toLowerCase()
                          : "";
                        const searchInput = input.toLowerCase();
                        return label.includes(searchInput);
                      }}
                      disabled={disabledPacienteSelect}
                    >
                      {patientOptions}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12}>
                  <Title level={4} className="traslado-section-title">
                    <FileTextOutlined className="traslado-section-icon" />
                    Seleccione Autorización
                  </Title>

                  <Form.Item name="autorizacion_id" hidden>
                    <Input type="hidden" />
                  </Form.Item>
                  <Form.Item
                    name="autorizacion"
                    label="Número de Autorización"
                    rules={[
                      {
                        required: true,
                        message:
                          "Seleccione una autorización o preautorización",
                        validator: (_, value) => {
                          if (value || form.getFieldValue("preautorizacion")) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              "Seleccione una autorización o preautorización"
                            )
                          );
                        },
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Seleccione una autorización"
                      onChange={handleAutorizacionChange}
                      optionFilterProp="label"
                      className="traslado-select"
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        option.label &&
                        option.label
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      disabled={disabledAutorizacionSelect}
                    >
                      {autorizacionOptions}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              {/* 2) Información del Paciente (deshabilitada) */}
              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={6}>
                      <Form.Item
                        name="nombre_paciente"
                        label="Nombre del Paciente"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                      <Form.Item
                        name="tipo_documento_paciente"
                        label="Tipo de Documento"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                      <Form.Item
                        name="numero_documento_paciente"
                        label="Número de Documento"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                      <Form.Item name="tipo_usuario" label="Tipo de Usuario">
                        <Input disabled />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={6}>
                      <Form.Item name="edad_paciente" label="Edad del Paciente">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                      <Form.Item
                        name="genero_paciente"
                        label="Género del Paciente"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                      <Form.Item
                        name="numero_contacto_paciente"
                        label="Teléfono del Paciente"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                      <Form.Item name="zona_paciente" label="Zona del Paciente">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* 3) Info de Autorización (deshabilitada) */}
              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  <Title level={4} className="traslado-section-title">
                    <InfoCircleOutlined className="traslado-section-icon" />
                    Información de Autorización
                  </Title>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={8}>
                      <Form.Item name="preautorizacion" label="Preautorización">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8}>
                      <Form.Item
                        name="tipo_autorizacion"
                        label="Tipo de Autorización"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8}>
                      <Form.Item
                        name="autorizacion"
                        label="Número de Autorización"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>

                    <Col xs={24}>
                      <Form.Item
                        name="observaciones_autorizacion"
                        label="Observaciones de la Autorización"
                      >
                        <TextArea disabled rows={3} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* 4) Info General del Traslado */}
              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  <Title level={4} className="traslado-section-title">
                    <CarOutlined className="traslado-section-icon" />
                    Información General
                  </Title>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={8}>
                      <Form.Item name="tipo_traslado" label="Tipo de Traslado">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8}>
                      <Form.Item name="tipo_viaje" label="Tipo de Viaje">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8}>
                      <Form.Item
                        name="traslados_restantes"
                        label="Traslados Restantes"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="observaciones_traslado"
                        label="Observaciones del Traslado"
                      >
                        <TextArea
                          rows={3}
                          placeholder="Ingrese las observaciones del traslado"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="indicaciones_conductor"
                        label="Observaciones del Conductor"
                      >
                        <TextArea
                          rows={3}
                          placeholder="Ingrese las observaciones del conductor"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* 5) Tarjetas Distancia / Tiempo */}
              <Row gutter={[16, 16]} className="traslado-cards-row">
                <Col xs={24} sm={12}>
                  <Card
                    title={
                      <span>
                        <EnvironmentOutlined className="traslado-card-icon" />
                        Distancia Aproximada
                      </span>
                    }
                    variant="borderless"
                    className="traslado-card"
                  >
                    <p className="traslado-card-text">
                      Ida: {calculatedDistance ? `${calculatedDistance} km` : "Esperando..."}
                    </p>
                    <p className="traslado-card-text">
                      Retorno:{" "}
                      {calculatedDistance ? `${calculatedDistance} km` : "Esperando..."}
                    </p>
                  </Card>
                </Col>
                <Col xs={24} sm={12}>
                  <Card
                    title={
                      <span>
                        <ClockCircleOutlined className="traslado-card-icon" />
                        Tiempo Aproximado
                      </span>
                    }
                    variant="borderless"
                    className="traslado-card"
                  >
                    <p className="traslado-card-text">
                      Ida:{" "}
                      {calculatedDuration || "Esperando..."}
                    </p>
                    <p className="traslado-card-text">
                      Retorno:{" "}
                      {calculatedDuration || "Esperando..."}
                    </p>
                  </Card>
                </Col>
              </Row>

              {/* 6) Info Médica (deshabilitada) */}
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Title level={4} className="traslado-section-title">
                    <MedicineBoxOutlined className="traslado-section-icon" />
                    Información Médica
                  </Title>

                  <Form.Item name="empresa" label="Empresa">
                    <Input disabled />
                  </Form.Item>
                  <Form.Item name="proposito" label="Propósito">
                    <Input disabled />
                  </Form.Item>
                  <Form.Item name="diagnostico_nombre" label="Diagnóstico">
                    <Input disabled />
                  </Form.Item>
                  <Form.Item name="copago" label="Copago Total">
                    <InputNumber
                      min={0}
                      style={{ width: "100%" }}
                      formatter={(valueNum) => formatCurrencyCOP(valueNum)}
                      parser={(valueStr) =>
                        valueStr
                          ? Number(
                              valueStr
                                .replace(/[^0-9.,-]/g, "")
                                .replace(/\./g, "")
                                .replace(/,/g, ".")
                            )
                          : 0
                      }
                      disabled
                    />
                  </Form.Item>

                  <Form.Item
                    name="parentesco_responsable"
                    label="Parentesco del Responsable"
                  >
                    <Input disabled />
                  </Form.Item>
                  <Form.Item
                    name="numero_contacto_responsable"
                    label="Teléfono del Responsable"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>

                {/* 7) Fechas y Horas del Viaje */}
                <Col xs={24} sm={12}>
                  <Title level={4} className="traslado-section-title" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <AimOutlined className="traslado-section-icon" />
                    <span style={{ flex: 1 }}>Información del Traslado</span>
                    <Popover title="Programar solo el retorno" trigger={['hover', 'focus', 'click']}
                      content={<div style={{ maxWidth: 'min(320px, calc(100vw - 64px))' }}>Para programar solo el retorno, complete únicamente sus dos horas. Se creará un solo traslado con origen y destino invertidos; no necesita usar Intercambiar.</div>}>
                      <Button type="text" size="small" shape="circle" aria-label="Ayuda para programar solo el retorno"
                        icon={<InfoCircleOutlined style={{ color: '#1677ff' }} />} />
                    </Popover>
                  </Title>

                  {/* Fechas Autorización */}
                  <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
                    <Col xs={24}>
                      <Typography level={5} style={{ marginBottom: "8px" }}>
                        Fechas de la Autorización
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          backgroundColor: "#f0f2f5",
                          padding: "8px 16px",
                          borderRadius: "8px",
                          border: "1px solid #d9d9d9",
                        }}
                      >
                        <Typography.Text
                          style={{ fontSize: "14px", fontWeight: "400" }}
                        >
                          <strong>Inicio:</strong>{" "}
                          {minFecha
                            ? minFecha.format("DD/MM/YYYY")
                            : "No definida"}
                        </Typography.Text>
                        <Typography.Text
                          style={{ fontSize: "14px", fontWeight: "400" }}
                        >
                          <strong>Fin:</strong>{" "}
                          {maxFecha
                            ? maxFecha.format("DD/MM/YYYY")
                            : "No definida"}
                        </Typography.Text>
                      </div>
                    </Col>
                  </Row>

                  <Form.Item name="fecha" label="Fecha">
                    <DatePicker
                      className="traslado-datepicker"
                      disabled={
                        !maxFecha || dayjs().isAfter(maxFecha.endOf("day"))
                      }
                      disabledDate={disabledDate}
                      placeholder={
                        !maxFecha
                          ? "Seleccione una autorización válida"
                          : dayjs().isAfter(maxFecha.endOf("day"))
                          ? "Autorización vencida"
                          : `Seleccione fecha (hasta ${maxFecha.format(
                              "DD/MM/YYYY"
                            )})`
                      }
                      allowClear={true}
                      style={{
                        width: "100%",
                        backgroundColor:
                          !maxFecha || dayjs().isAfter(maxFecha.endOf("day"))
                            ? "#f5f5f5"
                            : "#fff",
                      }}
                      onChange={validarEstadoAgendar}
                    />
                  </Form.Item>

                  {/* Hora de Recogida */}
                  <Form.Item
                    name="hora_recogida"
                    label="Hora de Recogida"
                    dependencies={camposHorario.filter(campo => campo !== "hora_recogida")}
                    rules={[
                      ({ getFieldValue }) => ({
                        required: horaObligatoria("hora_recogida", getFieldValue),
                        message: "Seleccione la hora de recogida",
                      }),
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const horaLlegada = getFieldValue("hora_llegada");
                          const horaRetornoRecogida = getFieldValue(
                            "hora_retorno_recogida"
                          );
                          const fecha = getFieldValue("fecha");
                          if (!value) return Promise.resolve();

                          // Usar hora del servidor para validaciones
                          const serverNow = getServerTime();
                          // Solo validamos hora en el pasado si la fecha es hoy
                          if (
                            fecha &&
                            fecha.isSame(serverNow, "day") &&
                            value.isBefore(serverNow)
                          ) {
                            return Promise.reject(
                              new Error(
                                "La hora de recogida no puede ser en el pasado"
                              )
                            );
                          }
                          if (horaLlegada && horaLlegada.isBefore(value)) {
                            return Promise.reject(
                              new Error(
                                "La hora de recogida no puede ser después de la hora de llegada"
                              )
                            );
                          }
                          if (
                            horaRetornoRecogida &&
                            !isAtLeast15MinutesAfter(value, horaRetornoRecogida)
                          ) {
                            return Promise.reject(
                              new Error(
                                "La hora de retorno de recogida debe ser al menos 15 minutos después de la hora de recogida"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                    getValueFromEvent={(_, timeString) => {
                      if (/^\d{3,4}$/.test(timeString)) {
                        const parsed = dayjs(timeString, "HHmm", true);
                        if (parsed.isValid()) return parsed;
                      }
                      const parsed = dayjs(timeString, "HH:mm", true);
                      return parsed.isValid() ? parsed : undefined;
                    }}
                  >
                    <TimePicker
                      className="traslado-timepicker"
                      format="HH:mm"
                      onChange={handleTimeChange}
                      disabledTime={disabledTimeFunc}
                      inputReadOnly={false}
                      placeholder="Selecciona o teclea la hora"
                      onBlur={(e) => {
                        const raw = e.target.value;
                        if (/^\d{3,4}$/.test(raw)) {
                          const h = Math.min(23, Math.floor(+raw / 100));
                          const m = Math.min(59, +raw % 100);
                          form.setFieldsValue({
                            hora_recogida: dayjs().hour(h).minute(m),
                          });
                        }
                        const horaRecogida =
                          form.getFieldValue("hora_recogida");
                        const fecha = form.getFieldValue("fecha");
                        // Usar hora del servidor para validaciones
                        const serverNow = getServerTime();
                        // Solo validamos hora en el pasado si la fecha es hoy
                        if (
                          fecha &&
                          fecha.isSame(serverNow, "day") &&
                          horaRecogida &&
                          horaRecogida.isBefore(serverNow)
                        ) {
                          form.setFields([
                            {
                              name: "hora_recogida",
                              errors: [
                                "La hora de recogida no puede ser en el pasado",
                              ],
                            },
                          ]);
                        } else {
                          form.setFields([
                            { name: "hora_recogida", errors: [] },
                          ]);
                        }
                      }}
                    />
                  </Form.Item>

                  {/* Hora de Llegada */}
                  <Form.Item
                    name="hora_llegada"
                    label="Hora de Llegada"
                    dependencies={camposHorario.filter(campo => campo !== "hora_llegada")}
                    rules={[
                      ({ getFieldValue }) => ({
                        required: horaObligatoria("hora_llegada", getFieldValue),
                        message: "Seleccione la hora de llegada",
                      }),
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const horaRecogida = getFieldValue("hora_recogida");
                          const horaRetornoRecogida = getFieldValue(
                            "hora_retorno_recogida"
                          );
                          const fecha = getFieldValue("fecha");
                          if (!value) return Promise.resolve();

                          // Usar hora del servidor para validaciones
                          const serverNow = getServerTime();
                          // Solo validamos hora en el pasado si la fecha es hoy
                          if (
                            fecha &&
                            fecha.isSame(serverNow, "day") &&
                            value.isBefore(serverNow)
                          ) {
                            return Promise.reject(
                              new Error(
                                "La hora de llegada no puede ser en el pasado"
                              )
                            );
                          }
                          if (
                            horaRecogida &&
                            !isAtLeast15MinutesAfter(horaRecogida, value)
                          ) {
                            return Promise.reject(
                              new Error(
                                "La hora de llegada debe ser al menos 15 minutos después de la hora de recogida"
                              )
                            );
                          }
                          if (
                            horaRetornoRecogida &&
                            !isAtLeast15MinutesAfter(value, horaRetornoRecogida)
                          ) {
                            return Promise.reject(
                              new Error(
                                "La hora de retorno de recogida debe ser al menos 15 minutos después de la hora de llegada"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                    getValueFromEvent={(_, timeString) => {
                      if (/^\d{3,4}$/.test(timeString)) {
                        const parsed = dayjs(timeString, "HHmm", true);
                        if (parsed.isValid()) return parsed;
                      }
                      const parsed = dayjs(timeString, "HH:mm", true);
                      return parsed.isValid() ? parsed : undefined;
                    }}
                  >
                    <TimePicker
                      className="traslado-timepicker"
                      format="HH:mm"
                      onChange={handleTimeChange}
                      disabledTime={disabledTimeFunc}
                      inputReadOnly={false}
                      placeholder="Selecciona o teclea la hora"
                      onBlur={(e) => {
                        const raw = e.target.value;
                        if (/^\d{3,4}$/.test(raw)) {
                          const h = Math.min(23, Math.floor(+raw / 100));
                          const m = Math.min(59, +raw % 100);
                          form.setFieldsValue({
                            hora_llegada: dayjs().hour(h).minute(m),
                          });
                        }
                        const horaLlegada = form.getFieldValue("hora_llegada");
                        const fecha = form.getFieldValue("fecha");
                        // Usar hora del servidor para validaciones
                        const serverNow = getServerTime();
                        // Solo validamos hora en el pasado si la fecha es hoy
                        if (
                          fecha &&
                          fecha.isSame(serverNow, "day") &&
                          horaLlegada &&
                          horaLlegada.isBefore(serverNow)
                        ) {
                          form.setFields([
                            {
                              name: "hora_llegada",
                              errors: [
                                "La hora de llegada no puede ser en el pasado",
                              ],
                            },
                          ]);
                        } else {
                          form.setFields([
                            { name: "hora_llegada", errors: [] },
                          ]);
                        }
                      }}
                    />
                  </Form.Item>

                  {/* Hora de Retorno (Recogida) */}
                  <Form.Item
                    name="hora_retorno_recogida"
                    label="Hora de Retorno (Recogida)"
                    dependencies={camposHorario.filter(campo => campo !== "hora_retorno_recogida")}
                    rules={[
                      ({ getFieldValue }) => ({
                        required: horaObligatoria("hora_retorno_recogida", getFieldValue),
                        message: "Seleccione la hora de retorno de recogida",
                      }),
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const horaLlegada = getFieldValue("hora_llegada");
                          const horaRetornoLlegada = getFieldValue(
                            "hora_retorno_llegada"
                          );
                          const fecha = getFieldValue("fecha");
                          if (!value) return Promise.resolve();

                          // Usar hora del servidor para validaciones
                          const serverNow = getServerTime();
                          // Solo validamos hora en el pasado si la fecha es hoy
                          if (
                            fecha &&
                            fecha.isSame(serverNow, "day") &&
                            value.isBefore(serverNow)
                          ) {
                            return Promise.reject(
                              new Error(
                                "La hora de retorno de recogida no puede ser en el pasado"
                              )
                            );
                          }
                          if (
                            horaLlegada &&
                            !isAtLeast15MinutesAfter(horaLlegada, value)
                          ) {
                            return Promise.reject(
                              new Error(
                                "La hora de retorno de recogida debe ser al menos 15 minutos después de la hora de llegada"
                              )
                            );
                          }
                          if (
                            horaRetornoLlegada &&
                            !isAtLeast15MinutesAfter(value, horaRetornoLlegada)
                          ) {
                            return Promise.reject(
                              new Error(
                                "La hora de retorno de llegada debe ser al menos 15 minutos antes de la hora de retorno de llegada"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                    getValueFromEvent={(_, timeString) => {
                      if (/^\d{3,4}$/.test(timeString)) {
                        const parsed = dayjs(timeString, "HHmm", true);
                        if (parsed.isValid()) return parsed;
                      }
                      const parsed = dayjs(timeString, "HH:mm", true);
                      return parsed.isValid() ? parsed : undefined;
                    }}
                  >
                    <TimePicker
                      className="traslado-timepicker"
                      format="HH:mm"
                      onChange={handleTimeChange}
                      disabledTime={disabledTimeFunc}
                      inputReadOnly={false}
                      placeholder="Selecciona o teclea la hora"
                      onBlur={(e) => {
                        const raw = e.target.value;
                        if (/^\d{3,4}$/.test(raw)) {
                          const h = Math.min(23, Math.floor(+raw / 100));
                          const m = Math.min(59, +raw % 100);
                          form.setFieldsValue({
                            hora_retorno_recogida: dayjs().hour(h).minute(m),
                          });
                        }
                        const horaRetornoRecogida = form.getFieldValue(
                          "hora_retorno_recogida"
                        );
                        const fecha = form.getFieldValue("fecha");
                        // Usar hora del servidor para validaciones
                        const serverNow = getServerTime();
                        // Solo validamos hora en el pasado si la fecha es hoy
                        if (
                          fecha &&
                          fecha.isSame(serverNow, "day") &&
                          horaRetornoRecogida &&
                          horaRetornoRecogida.isBefore(serverNow)
                        ) {
                          form.setFields([
                            {
                              name: "hora_retorno_recogida",
                              errors: [
                                "La hora de retorno de recogida no puede ser en el pasado",
                              ],
                            },
                          ]);
                        } else {
                          form.setFields([
                            { name: "hora_retorno_recogida", errors: [] },
                          ]);
                        }
                      }}
                    />
                  </Form.Item>

                  {/* Hora de Retorno (Llegada) */}
                  <Form.Item
                    name="hora_retorno_llegada"
                    label="Hora de Retorno (Llegada)"
                    dependencies={camposHorario.filter(campo => campo !== "hora_retorno_llegada")}
                    rules={[
                      ({ getFieldValue }) => ({
                        required: horaObligatoria("hora_retorno_llegada", getFieldValue),
                        message: "Seleccione la hora de retorno de llegada",
                      }),
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const horaRetornoRecogida = getFieldValue(
                            "hora_retorno_recogida"
                          );
                          const fecha = getFieldValue("fecha");
                          if (!value) return Promise.resolve();

                          // Usar hora del servidor para validaciones
                          const serverNow = getServerTime();
                          // Solo validamos hora en el pasado si la fecha es hoy
                          if (
                            fecha &&
                            fecha.isSame(serverNow, "day") &&
                            value.isBefore(serverNow)
                          ) {
                            return Promise.reject(
                              new Error(
                                "La hora de retorno de llegada no puede ser en el pasado"
                              )
                            );
                          }
                          if (
                            horaRetornoRecogida &&
                            !isAtLeast15MinutesAfter(horaRetornoRecogida, value)
                          ) {
                            return Promise.reject(
                              new Error(
                                "La hora de retorno de llegada debe ser al menos 15 minutos después de la hora de retorno de recogida"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                    getValueFromEvent={(_, timeString) => {
                      if (/^\d{3,4}$/.test(timeString)) {
                        const parsed = dayjs(timeString, "HHmm", true);
                        if (parsed.isValid()) return parsed;
                      }
                      const parsed = dayjs(timeString, "HH:mm", true);
                      return parsed.isValid() ? parsed : undefined;
                    }}
                  >
                    <TimePicker
                      className="traslado-timepicker"
                      format="HH:mm"
                      onChange={handleTimeChange}
                      disabledTime={disabledTimeFunc}
                      inputReadOnly={false}
                      placeholder="Selecciona o teclea la hora"
                      onBlur={(e) => {
                        const raw = e.target.value;
                        if (/^\d{3,4}$/.test(raw)) {
                          const h = Math.min(23, Math.floor(+raw / 100));
                          const m = Math.min(59, +raw % 100);
                          form.setFieldsValue({
                            hora_retorno_llegada: dayjs().hour(h).minute(m),
                          });
                        }
                        const horaRetornoLlegada = form.getFieldValue(
                          "hora_retorno_llegada"
                        );
                        const fecha = form.getFieldValue("fecha");
                        // Usar hora del servidor para validaciones
                        const serverNow = getServerTime();
                        // Solo validamos hora en el pasado si la fecha es hoy
                        if (
                          fecha &&
                          fecha.isSame(serverNow, "day") &&
                          horaRetornoLlegada &&
                          horaRetornoLlegada.isBefore(serverNow)
                        ) {
                          form.setFields([
                            {
                              name: "hora_retorno_llegada",
                              errors: [
                                "La hora de retorno de llegada no puede ser en el pasado",
                              ],
                            },
                          ]);
                        } else {
                          form.setFields([
                            { name: "hora_retorno_llegada", errors: [] },
                          ]);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* 8) Origen y Destino */}
              {geografiaTraslado.error && <GeografiaAlert type="warning" showIcon message={geografiaTraslado.error} />}
              <Row gutter={[16, 16]}>
                {/* ORIGEN */}
                <Col xs={24} sm={11}>
                  <Title level={4} className="traslado-section-title">
                    <AimOutlined className="traslado-section-icon" />
                    Origen
                  </Title>

                  <Form.Item name="origen_lugar" label="Lugar">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Seleccione un lugar"
                      open={origenSelectOpen}
                      onDropdownVisibleChange={setOrigenSelectOpen}
                      onSearch={(value) => setSearchTextOrigen(value)}
                      onChange={handleOrigenChange}
                      dropdownRender={(menu) =>
                        renderDropdownMenu(
                          menu,
                          searchTextOrigen,
                          instituciones,
                          handleAgregarLugarTemporalOrigen
                        )
                      }
                      style={{ width: "100%" }}
                      filterOption={(input, option) => {
                        const label = option.label
                          ? option.label.toLowerCase()
                          : "";
                        const searchInput = input.toLowerCase();
                        return label.includes(searchInput);
                      }}
                    >
                      {geografiaTraslado.domicilio?.('origen') && <Option key="domicilio" value="Domicilio" label="Domicilio">Domicilio</Option>}
                {geografiaTraslado.filtrar(instituciones, 'institucion', 'origen').map((inst) => (
                        <Option
                          key={inst.id}
                          value={inst.id}
                          label={inst.nombre}
                        >
                          {inst.nombre}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  {origenEsTemporal && (
                    <Button
                      style={{ marginBottom: 16 }}
                      icon={<EnvironmentOutlined />}
                      onClick={() => {
                        setMapMode("origen");
                        setMapVisible(true);
                      }}
                    >
                      Buscar en el mapa (Origen)
                    </Button>
                  )}

                  <Form.Item name="origen_direccion" label="Dirección">
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="origen_departamento"
                    label="Departamento (Origen)"
                    rules={[
                      { required: true, message: "Seleccione un departamento" },
                    ]}
                  >
                    <SelectUbicacionPermitida
                      placeholder="Seleccione un departamento"
                      disabled={!geografiaTraslado.contexto?.configurada}
                      options={geografiaTraslado.filtrar(departamentos, 'departamento', 'origen').map(item => ({ value: item.id, label: item.nombre }))}
                      onChange={handleChangeOrigenDepartamento}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="origen_ciudad"
                    label="Ciudad (Origen)"
                    rules={[
                      { required: true, message: "Seleccione una ciudad" },
                    ]}
                  >
                    <SelectUbicacionPermitida
                      placeholder="Seleccione una ciudad"
                      disabled={!geografiaTraslado.contexto?.configurada}
                      options={geografiaTraslado.filtrar(ciudadesOrigen, 'ciudad', 'origen').map(item => ({ value: item.id, label: item.nombre }))}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                  <Form.Item name="origen_localidad" label="Localidad">
                    <Input />
                  </Form.Item>
                  <Form.Item name="origen_barrio" label="Barrio">
                    <Input />
                  </Form.Item>
                  <Form.Item name="origen_vereda_corregimiento" label="Vereda/Corregimiento">
                    <Input placeholder="Opcional" />
                  </Form.Item>
                  <Form.Item name="origen_indicaciones" label="Indicaciones">
                    <TextArea rows={2} />
                  </Form.Item>
                  <Form.Item
                    name="origen_coordenadas"
                    label="Coordenadas"
                    rules={[
                      { required: true, message: "Las coordenadas de origen son requeridas" },
                      coordinateValidationRule(true),
                    ]}
                  >
                    <Input
                      placeholder="Ej: 4.6097, -74.0817"
                      onChange={(e) => {
                        const origenCoords = e.target.value;
                        setTimeout(() => {
                          const destinoCoords = form.getFieldValue('destino_coordenadas');
                          calculateDistanceAndTime(origenCoords, destinoCoords);
                        }, 500);
                      }}
                    />
                  </Form.Item>
                </Col>

                {/* Botón SWAP */}
                <Col xs={24} sm={2} className="traslado-swap-col">
                  <Button
                    icon={<SwapOutlined />}
                    size="large"
                    shape="circle"
                    aria-label="Intercambiar origen y destino"
                    title="Intercambiar origen y destino si la autorización lo permite"
                    onClick={swapOrigenDestino}
                  />
                </Col>

                {/* DESTINO */}
                <Col xs={24} sm={11}>
                  <Title level={4} className="traslado-section-title">
                    <AimOutlined className="traslado-section-icon" />
                    Destino
                  </Title>

                  <Form.Item name="destino_lugar" label="Lugar">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Seleccione un lugar"
                      open={destinoSelectOpen}
                      onDropdownVisibleChange={setDestinoSelectOpen}
                      onSearch={(value) => setSearchTextDestino(value)}
                      onChange={handleDestinoChange}
                      dropdownRender={(menu) =>
                        renderDropdownMenu(
                          menu,
                          searchTextDestino,
                          instituciones,
                          handleAgregarLugarTemporalDestino
                        )
                      }
                      style={{ width: "100%" }}
                      filterOption={(input, option) => {
                        const label = option.label
                          ? option.label.toLowerCase()
                          : "";
                        const searchInput = input.toLowerCase();
                        return label.includes(searchInput);
                      }}
                    >
                      {geografiaTraslado.domicilio?.('destino') && <Option key="domicilio" value="Domicilio" label="Domicilio">Domicilio</Option>}
                {geografiaTraslado.filtrar(instituciones, 'institucion', 'destino').map((inst) => (
                        <Option
                          key={inst.id}
                          value={inst.id}
                          label={inst.nombre}
                        >
                          {inst.nombre}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  {destinoEsTemporal && (
                    <Button
                      style={{ marginBottom: 16 }}
                      icon={<EnvironmentOutlined />}
                      onClick={() => {
                        setMapMode("destino");
                        setMapVisible(true);
                      }}
                    >
                      Buscar en el mapa (Destino)
                    </Button>
                  )}

                  <Form.Item name="destino_direccion" label="Dirección">
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="destino_departamento"
                    label="Departamento (Destino)"
                    rules={[
                      { required: true, message: "Seleccione un departamento" },
                    ]}
                  >
                    <SelectUbicacionPermitida
                      placeholder="Seleccione un departamento"
                      disabled={!geografiaTraslado.contexto?.configurada}
                      options={geografiaTraslado.filtrar(departamentos, 'departamento', 'destino').map(item => ({ value: item.id, label: item.nombre }))}
                      onChange={handleChangeDestinoDepartamento}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="destino_ciudad"
                    label="Ciudad (Destino)"
                    rules={[
                      { required: true, message: "Seleccione una ciudad" },
                    ]}
                  >
                    <SelectUbicacionPermitida
                      placeholder="Seleccione una ciudad"
                      disabled={!geografiaTraslado.contexto?.configurada}
                      options={geografiaTraslado.filtrar(ciudadesDestino, 'ciudad', 'destino').map(item => ({ value: item.id, label: item.nombre }))}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                  <Form.Item name="destino_localidad" label="Localidad">
                    <Input />
                  </Form.Item>
                  <Form.Item name="destino_barrio" label="Barrio">
                    <Input />
                  </Form.Item>
                  <Form.Item name="destino_vereda_corregimiento" label="Vereda/Corregimiento">
                    <Input placeholder="Opcional" />
                  </Form.Item>
                  <Form.Item name="destino_indicaciones" label="Indicaciones">
                    <TextArea rows={2} />
                  </Form.Item>
                  <Form.Item
                    name="destino_coordenadas"
                    label="Coordenadas"
                    rules={[
                      { required: true, message: "Las coordenadas de destino son requeridas" },
                      coordinateValidationRule(true),
                    ]}
                  >
                    <Input
                      placeholder="Ej: 4.6097, -74.0817"
                      onChange={(e) => {
                        const destinoCoords = e.target.value;
                        setTimeout(() => {
                          const origenCoords = form.getFieldValue('origen_coordenadas');
                          calculateDistanceAndTime(origenCoords, destinoCoords);
                        }, 500);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Información calculada automáticamente */}
              <Row gutter={16} style={{ marginTop: 16 }}>
                <Col xs={24} sm={12}>
                  <Form.Item name="distancia_km" label="Distancia Calculada">
                    <Input 
                      readOnly 
                      suffix="km" 
                      placeholder="Calculada automáticamente"
                      style={{ backgroundColor: '#f5f5f5' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item name="tiempo_estimado" label="Tiempo Estimado">
                    <Input 
                      readOnly 
                      placeholder="Calculado automáticamente"
                      style={{ backgroundColor: '#f5f5f5' }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Botón para Ver Ruta (MapRoute) */}
              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  <Button
                    type="primary"
                    onClick={handleOpenMap}
                    className="traslado-map-button"
                    disabled={!origin || !destination}
                  >
                    Ver ruta en el mapa
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </div>
      </Modal>

      {/* MAPDIALOG => para buscar coords */}
      <MapDialog
        open={mapVisible && mapMode !== null}
        onClose={handleCloseMap}
        onSelect={handleMapSelect}
        initialCoords=""
      />

      {/* MAPROUTE => para ver la ruta final */}
      <MapRoute
        open={mapVisible && mapMode === null}
        onClose={handleCloseMap}
        origin={origin || { lat: 0, lng: 0 }}
        destination={destination || { lat: 0, lng: 0 }}
      />

      {/* Modal de Agendar */}
      <AgendarDialog
        open={isAgendarVisible}
        onClose={handleAgendarClose}
        onCloseParentDialog={onClose}
        form={form}
        minFecha={(minFecha || dayjs().startOf("day")).format("YYYY-MM-DD")}
        maxFecha={(maxFecha || dayjs().add(1, "year")).format("YYYY-MM-DD")}
        distance={calculatedDistance || 0}
        duration={calculatedDuration || "0 min"}
        distanceReturn={calculatedDistance || 0}
        durationReturn={calculatedDuration || "0 min"}
        // ¡OJO! Estos cuatro props son necesarios:
        instituciones={instituciones} // Aquí tu array real
        departamentos={departamentos} // Aquí tu array real
        ciudadesOrigen={ciudadesOrigen} // El array con las ciudades de origen
        ciudadesDestino={ciudadesDestino} // El array con las ciudades de destino
      />
    </>
  );
}

// Cada apertura crea un formulario nuevo, incluso si la pantalla padre conserva el modal montado.
function TrasladoDialog(props) {
  return props.open ? <FormularioTraslado {...props} /> : null;
}

TrasladoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialPacienteId: PropTypes.number,
  initialAutorizacionId: PropTypes.number,
  disabledPacienteSelect: PropTypes.bool,
  disabledAutorizacionSelect: PropTypes.bool,
  isTai: PropTypes.bool, // null = todas, true = solo TAI, false = solo normales
};

export default TrasladoDialog;
